if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      

      onSubmitHandler(evt) {
        evt.preventDefault();
  
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      if (this.submitButton.getAttribute('data-charm') === 'nomination') {
        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity'), 10) || 1;

        fetch('/cart.js')
          .then(response => response.json())
          .then(async cart => {

              const charmExists = cart.items.some(item =>
                item.product_type?.toLowerCase() === 'charms'
              );

        if (charmExists) {
          // Charm exists → add bracelet normally
          console.log('Charm exists - adding bracelet normally');

          const cartDrawer = document.querySelector('cart-drawer');

          const sectionsToRender = cartDrawer &&
            typeof cartDrawer.getSectionsToRender === 'function'
              ? cartDrawer.getSectionsToRender().map(s => s.id)
              : ['cart-drawer', 'cart-icon-bubble'];

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: quantity
              }],
              sections: sectionsToRender,
              sections_url: window.location.pathname
            })
          });

          if (!response.ok) {
              const errorData = await response.json().catch(() => ({}));
                const message = errorData.description || errorData.message || 'Failed to add bracelet';
                throw new Error(message);
          }

          const data = await response.json();

          // Update + open cart drawer
          if (cartDrawer) {
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            }

            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('active');
            }
          }

        } else {
          // No charm → open charm popup
          console.log('No charm - opening charm popup');

          const charmPopup = document.querySelector('#charm-selection-popup');

          if (charmPopup) {
            charmPopup.classList.add('is-open');
            charmPopup.dataset.productVariantId = variantId;
            charmPopup.dataset.productQuantity = quantity; 
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
         this.handleErrorMessage(error.message || 'Something went wrong. Please try again.');
      });

    return;
  }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        if (!errorMessageWrapper) return;

        const errorMessageEl = errorMessageWrapper.querySelector('.product-form__error-message');

        clearTimeout(this.errorMessageTimeout);

        errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && errorMessageEl) {
          errorMessageEl.textContent = errorMessage;

          this.errorMessageTimeout = setTimeout(() => {
            errorMessageWrapper.setAttribute('hidden', '');
          }, 2000);
        }
      }


        

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
